import { render, staticRenderFns } from "./ChartDoughnutType1.vue?vue&type=template&id=491d9989&"
import script from "./ChartDoughnutType1.vue?vue&type=script&lang=js&"
export * from "./ChartDoughnutType1.vue?vue&type=script&lang=js&"
import style0 from "./ChartDoughnutType1.vue?vue&type=style&index=0&id=491d9989&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports